import { Component } from 'react';
import './App.css'
import Image from "react-graceful-image";

import artwork from './images/ceiling-waves-vinyl.png'
import we_sang_handwritten from './images/we-sang.svg'

class WeSangSmartLinks extends Component {
	render() {
		return (
			<div className="Smart-links">
				<div className="Smart-link-buttons-left">
					<div>
						<div className="Small-smart-links-text">listen to the new single</div>
						<img className="Smart-links-handwritten-text" src={we_sang_handwritten}></img>
					</div>
					<a href="https://sheepdogwolf.bandcamp.com/track/we-sang-as-you-slept"><btn className="Smart-link-button">bandcamp</btn></a>
					<a href="https://tidal.com/album/522215218"><btn className="Smart-link-button">tidal</btn></a>
					<a href="https://link.deezer.com/s/33rpxR705Ev3cvkUDhtj9"><btn className="Smart-link-button">deezer</btn></a>
					<a href="https://music.apple.com/nz/album/we-sang-as-you-slept-single/1896372141"><btn className="Smart-link-button">apple music</btn></a>
					<a href="https://open.spotify.com/playlist/58RijCEF7qQG2zGjI2UAbY?si=lyrk6QvCTO6cG62CGrHkSA"><btn className="Smart-link-button">spotify</btn></a>
					<div className="Spotify-notice">
					IF YOU ARE A SPOTIFY USER, PLEASE CONSIDER USING ANOTHER STREAMING SERVICE. <a href="https://www.cnbc.com/2025/06/17/spotifys-daniel-ek-leads-investment-in-defense-startup-helsing.html">THEIR CEO HEAVILY INVESTS IN AI WEAPONS TECH</a>. I DONATE MY SPOTIFY PROFITS TO MEDICAL AID FOR PALESTINIANS.
				</div>
				</div>
				<div className="Smart-link-feature-image-right">
					<a href="https://sheepdogwolf.bandcamp.com/album/ceiling-waves"><Image src={artwork} noLazyLoad="true" placeholderColor="#000" className="Smart-link-single-artwork" /></a>
					<br></br>
					<div className="Smart-link-buttons">
					<a href="https://sheepdogwolf.bandcamp.com/album/ceiling-waves"><btn className="Smart-link-button">pre-order ltd. edition vinyl</btn></a>
					<a href="https://open.spotify.com/prerelease/2qjNDno4N82aEXJ8iSt98F?si=lFTR9RsRSHKgQsa9kft_6Q"><btn className="Smart-link-button">pre-save album</btn></a>
					</div>
				</div>
			</div>
		);
	}
}

export default WeSangSmartLinks;